import { render, staticRenderFns } from "./mainFour.vue?vue&type=template&id=e6cda4d0&scoped=true&"
import script from "./mainFour.vue?vue&type=script&lang=js&"
export * from "./mainFour.vue?vue&type=script&lang=js&"
import style0 from "./mainFour.vue?vue&type=style&index=0&id=e6cda4d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cda4d0",
  null
  
)

export default component.exports